import { render } from "./addCustomers.vue?vue&type=template&id=377c4bfa&scoped=true"
import script from "./addCustomers.vue?vue&type=script&lang=js"
export * from "./addCustomers.vue?vue&type=script&lang=js"

import "./addCustomers.vue?vue&type=style&index=0&id=377c4bfa&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377c4bfa"]])

export default __exports__